/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
  $('body').on('click','.open_quick_modal', function(e) {
    e.preventDefault();
    $('body').addClass('active_quick_modal');
    var quick_add_modal = $(this).closest('.ProductItem').next('.quick_add_modal'); 
    var cloneModal = quick_add_modal.clone(true);
    cloneModal.addClass('clone_modal');
    $('body').append(cloneModal);
    cloneModal.addClass('active');
  });

  $('body').on('click','.close_quick_add_modal', function(e) {
    e.preventDefault();
    $('body').removeClass('active_quick_modal');
    $(this).closest('.quick_add_modal').removeClass('active');
    setTimeout(function() {
      $(this).closest('.quick_add_modal').remove();
    },500);



  });

  $('body').on('change','.ProductItem__MainSelect', function(e) {
    e.preventDefault();

 
    var val = $(this).val();
    var submitFormBtn = $(this).closest('form').find('.ProductForm__AddToCart');
    var form_error = $(this).closest('form').find('.slidecart-form-error');
    if(form_error.length) {
    	form_error.remove();
    }
                                     
    
    var activeOption = $(this).find('option:selected');
    var isAvailable = activeOption.attr('data-variant-available');
    if(isAvailable == 'true') {
    submitFormBtn.trigger('click');
      $(this).val(' ');
    } else {
    	var form = $(this).closest('form');
      form.append('<div class="error slidecart-form-error">' + window.languages.soldout_grid_text + '</div>');
    }
  });
  
   $('body').on('click','.quick_add_modal  .ProductForm__Variants label', function(e) {
    e.preventDefault();
     
     var input = $(this).prev();
     input.trigger('click');
   });

  $('body').on('change','.quick_add_modal .ProductForm__Option [type="radio"]', function(e) {
    e.preventDefault();

  
    
    var form =  $(this).closest('form');
    var main_select = form.find('.main_select');


   var variantId = $(this).attr('data-variant_id') * 1;
      main_select.val(variantId);
      main_select.trigger('change');

    $(this).removeAttr('checked');
    $(this).prop('checked',false);


  });

  $('body').on('change','.quick_add_modal .main_select', function(e) {
    e.preventDefault();
    
    var self = $(this);
    var quick_add_modalEl = self.closest('.quick_add_modal');

        var items = [];
 
      var variant_id = self.val() * 1;
      var variant_obj =  {
        quantity:1,
        id:variant_id
      };
      items.push(variant_obj);
 
      var data_arr = {
        items: items
      };
 
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data_arr)
      }).then(function (response) {
        if (response.ok) {


              if($('body').hasClass('active_quick_modal')) {
      $('body').removeClass('active_quick_modal');
      $('.quick_add_modal.clone_modal').removeClass('active');
      setTimeout(function() {
        $('.quick_add_modal.clone_modal').remove();
      },500);

    }
          
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: variant_id,
              quantity: 1
            }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
 
        } else {
          response.json().then(function (content) {
            var errorMessageElement = document.createElement('span');
            errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
            errorMessageElement.innerHTML = content['description'];
            quick_add_modalEl.insertAdjacentElement('afterend', errorMessageElement);
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
          });
        }
      });

  });

  $('body').on('click', function(e) {
    var el = e.target;
    if($(el).hasClass('active_quick_modal')) {
      $(el).removeClass('active_quick_modal');
      $('.quick_add_modal.clone_modal').removeClass('active');
      setTimeout(function() {
        $('.quick_add_modal.clone_modal').remove();
      },500);

    }
  });

  $('body').on('change','.product_option_input', function(e) {
    e.preventDefault();
    var form =  $(this).closest('form');
    var main_select = form.find('.ProductItem__MainSelect');
   
    var ProductItemEl = form.closest('.ProductItem');
    var variantId = $(this).attr('data-variant_id') * 1;
      main_select.val(variantId);
      main_select.trigger('change');

    $(this).removeAttr('checked');
    $(this).prop('checked',false);
  });

  $('body').on('click','.ProductItem__CustomSwatch', function (e) {
    e.preventDefault();

  
    
    const parentItemEl = $(this).closest('.ProductItem');
    if(parentItemEl.length) {

      let ProductItem__ImageLoaderIconEl = parentItemEl.find('.ProductItem__ImageLoaderIcon');
     
      
        let itemUrl = $(this).attr('data-product_url');
      let featuredMedia = $(this).attr('data-product_media');
      let alternateMedia = $(this).attr('data-product_alternate_image');
      let newTitle = $(this).attr('data-product_title');
      let itemId = $(this).attr('data-product-id');

      
     const old_desktop_quick_addEl = parentItemEl.find('.desktop_quick_add:not(.no-js)');
      const news_desktop_quick_addEl = parentItemEl.find('.desktop_quick_add[data-product-id="'+itemId+'"]');
      
      const ProductItem__ImageWrapperEl = parentItemEl.find('.ProductItem__ImageWrapper');
      const ProductItem__ImageEl = parentItemEl.find('.ProductItem__Image:not(.ProductItem__Image--alternate)');
      const ProductItem__ImageAlternateEl = parentItemEl.find('.ProductItem__Image--alternate');
      const ProductItemLinksArr =  parentItemEl.find('a:not(.ProductItem__CustomSwatch)');
      const ProductItem__TitleEl = parentItemEl.find('.ProductItem__Title');


       if(ProductItem__ImageLoaderIconEl.length) {
        ProductItem__ImageLoaderIconEl.removeClass('no-js');       
        ProductItem__ImageEl.css("visibility", "hidden");
      }
      
      if(ProductItemLinksArr.length) {
        for(const linkEl of ProductItemLinksArr) {
          $(linkEl).attr('href',itemUrl);
        }
      }
      if(ProductItem__TitleEl.length) {
        ProductItem__TitleEl.find('a').html(newTitle);
      }
        //debugger;

      if(ProductItem__ImageEl.length) {

        console.log(featuredMedia);
        ProductItem__ImageEl.attr('data-srcset',featuredMedia);
        ProductItem__ImageEl.attr('srcset',featuredMedia);
        ProductItem__ImageEl.attr('src',featuredMedia);
      }
  
      if(alternateMedia.length) {
            if(ProductItem__ImageAlternateEl.length) {
              console.log(alternateMedia);
        ProductItem__ImageAlternateEl.attr('data-srcset',alternateMedia);
        ProductItem__ImageAlternateEl.attr('srcset',alternateMedia);
        ProductItem__ImageAlternateEl.attr('src',alternateMedia);
        ProductItem__ImageWrapperEl.addClass('ProductItem__ImageWrapper--withAlternateImage');
      }
    } else {      
        ProductItem__ImageWrapperEl.removeClass('ProductItem__ImageWrapper--withAlternateImage');
    }



  
  
      if(news_desktop_quick_addEl.length) {
        news_desktop_quick_addEl.removeClass('no-js');

        if(old_desktop_quick_addEl.length) {
          old_desktop_quick_addEl.addClass('no-js');
        }
      }

    ProductItem__ImageEl[0].addEventListener('load', () => {
      if(ProductItem__ImageLoaderIconEl.length) {          
        setTimeout(() => {
        ProductItem__ImageLoaderIconEl.addClass('no-js');
        ProductItem__ImageEl.css("visibility", "visible");
      }, 300);
      }
  }, { once: true });

        

      
    }
  });

});